import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutAgencyPayeeLookup extends Layout {
    sourcePayeeDrsPayeeAgency: DataSource;
    tablePayeeDrsPayeeAgency: Table;
}
